<template>
  <div class="text-center">
    <v-dialog
        v-model="dialog"
        width="95%"
        scrollable
    >
      <v-card>
        <v-card-text style="height: 50rem;">


          <v-tabs
              v-model="tab"
              align-with-title

              centered
              icons-and-text
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tabela-preco">
              Tabelas
              <v-icon>mdi-table-star</v-icon>
            </v-tab>

            <v-tab href="#cartaz">
              Cartazes
              <v-icon>mdi-newspaper</v-icon>
            </v-tab>

            <v-tab href="#link">
              URL
              <v-icon>mdi-link-variant</v-icon>
            </v-tab>
          </v-tabs>

          <p
              class="headline ma-3 mb-0"
              primary-title
          >
            Selecione um componente
          </p>

          <v-tabs-items
              v-model="tab"
          >

            <v-tab-item
                value="tabela-preco"
            >
              <v-card
                  flat
              >
                <v-card-title>Tabela de preços</v-card-title>
                <v-card-subtitle>
                  Selecione uma tabela de preço para adicionar na divisão do quadro
                  selecionado
                </v-card-subtitle>

                <v-divider></v-divider>

                <TabelaPrecoList
                    is-used-into-another-view
                    v-on:emitItem="selecionaComponente"
                ></TabelaPrecoList>
              </v-card>
            </v-tab-item>

            <v-tab-item
                value="cartaz"
            >
              <v-card
                  flat
              >
                <v-card-title>Cartaz</v-card-title>
                <v-card-subtitle>
                  Selecione um modelo de cartaz para adicionar na divisão do quadro
                  selecionado
                </v-card-subtitle>

                <v-divider></v-divider>

                <ModelosCartaz
                    v-on:emitItem="selecionaComponente"
                ></ModelosCartaz>
              </v-card>
            </v-tab-item>

            <v-tab-item
                value="link"
            >
              <v-card flat>
                <v-card-title>URL</v-card-title>

                <v-card-subtitle>
                  Informe a URL para adicionar na divisão do quadro
                  selecionado
                </v-card-subtitle>

                <v-divider></v-divider>

                <v-card-text>Em breve</v-card-text>
              </v-card>
            </v-tab-item>

          </v-tabs-items>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="secondary"
              @click="dialog = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn
        icon
        color="blue"
        @click="abreModalSelecaoComponente()"
    >
      <v-icon>
        mdi-toy-brick-plus-outline
      </v-icon>
    </v-btn>

  </div>

</template>

<script>
import TabelaPrecoList from "../../tabela-preco/TabelaPrecoList";
import Mercadoria from "../../Mercadoria";
import {timelineMixin} from "../timelineMixin";
import ModelosCartaz from "./ModelosCartaz";

export default {
  name: "SelecionaComponente",
  mixins: [timelineMixin],
  props: {
    divisaoLayout: {
      type: Number,
      required: true
    },
  },
  components: {ModelosCartaz, Mercadoria, TabelaPrecoList},
  data() {
    return {
      dialog: false,
      tab: null,
    }
  },
  methods: {
    abreModalSelecaoComponente() {
      //seta a divisao p/ ele saber onde gravar o componente
      this.setDivisaoNumeroEmEdicao(this.divisaoLayout);
      this.dialog = true;
    },

    selecionaComponente(obj) {
      switch (this.tab) {
        case 'tabela-preco':
          this.$store.commit('setTimelineDadosComponente', {
            componenteTipo: this.tab,
            componenteDados: obj.item
          });
          break;

        case 'cartaz':
          this.$store.commit('setTimelineDadosComponente', {
            componenteTipo: this.tab,
            componenteDados: obj.item,
            configs: obj.item.configs
          });
          break;
      }

      this.dialog = false;
    },
  },
}
</script>
